import { restClient } from "libs/restClient";
import { testStringStatuses } from "helpers/RequestTestsHelper";
import { requestStatuses } from "helpers/RequestHelper";
import { notifyMessages } from "helpers/NotifyHelper";
import * as actions from "actions/types";
import * as call from "helpers/ActionHelper";

//=== Actions
export function fetchCertificationRequests(page, size, statusFilter) {
  const filterList = statusFilter.join();
  const url = `/requests/table?page=${page}&perpage=${size}&orderBy=transactionnumber DESC&where=requeststatusid IN (${filterList})`;
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.FETCH_CERTIFICATION_REQUESTS,
    payload
  };
}

export function clearRequests() {
  return { type: actions.CLEAR_REQUESTS };
}

export function fetchApproveWaitingRequests() {
  const url = `/requests/table?page=0&orderBy=transactionnumber DESC&where=requeststatusid=${requestStatuses.underReview}`;
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.FETCH_APPROVE_WAITING_REQUESTS,
    payload
  };
}

export function countApproveWaitingRequests() {
  const url = `/requests/table?page=0&orderBy=transactionnumber DESC&where=requeststatusid=${requestStatuses.underReview}`;
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.COUNT_APPROVE_WAITING_REQUESTS,
    payload
  };
}

const get__modelList = () => async dispatch => {
  try {
    const url = `/devicemodels?page=0`;
    const models = await restClient.get(url);

    dispatch({
      type: actions.FETCH_MODEL_LIST,
      payload: models
    });

    return models;
  } catch (e) {
    dispatch(call.showNotice(notifyMessages.errorFetchRequestAction));

    return Promise.reject(e);
  }
};

export const fetchModelList = () => async dispatch => {
  dispatch(call.startPreloader());
  dispatch(get__modelList())
    .then(() => dispatch(call.stopPreloader()))
    .catch(() => dispatch(call.stopPreloader()));
};

export function fetchRequestsForTesting(page, size, statusFilter) {
  // === old-fashioned method with id-based statuses ===
  // const filterList = statusFilter.join();
  // === --- ===
  const filterList = statusFilter.map(status => `'${status}'`).join(",");
  const { pending, approved, awaitingParent, underReview } = requestStatuses;
  const statusList = `${pending}, ${approved}, ${awaitingParent}, ${underReview}`;

  const url = `/requests/table?page=${page}&perpage=${size}&orderBy=transactionnumber DESC&where=testingstatus IN (${filterList}) AND requeststatusid IN (${statusList})`;
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.FETCH_CERTIFICATION_REQUESTS,
    payload
  };
}

export function fetchApprovedRequestsForTesting() {
  const { accepted, underReview, complete } = testStringStatuses;
  const { requestWithdrawn } = requestStatuses;
  const testStatusList = `'${accepted}', '${underReview}', '${complete}'`;

  const url = `/requests/table?orderBy=transactionnumber DESC&where=requeststatusid <> ${requestWithdrawn} AND testingstatus IN (${testStatusList})&page=0`;
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.FETCH_REQUEST_FOR_TESTING,
    payload
  };
}

export const fetchUnpaidRequests = () => async dispatch => {
  try {
    const { saved, requestWithdrawn } = requestStatuses;
    const url = `/requests?page=0&orderBy=transactionnumber DESC&include=invoice,billing(address)&where=paid=0 AND billingid IS NOT NULL AND requeststatusid NOT IN (${saved},${requestWithdrawn}) AND testingstatus IN ('Accepted','Under Review','Complete')`;
    const response = await restClient.get(url);

    dispatch({
      type: actions.FETCH_UNPAID_REQUESTS,
      payload: response.data.data
    });
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.errorAsyncAction
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/requests.js